/* eslint-disable @typescript-eslint/no-explicit-any */
// config/org.config.ts
import { services as limsServices } from './lims/services';

export type HeaderLink = {
  kind: string;
  title: string;
  url?: string; // direct link (no dropdown)
  external?: boolean; // open in new tab for absolute links
  children?: HeaderLink[]; // dropdown items
};

export const limsConfig = {
  name: 'LIMS',
  themeMode: 'light', // default: "light" | can toggle dynamically
  theme: {
    light: {
      primary: '#008236', // Base green
      secondary: '#00a64d', // Lighter shade of green
      accent: '#006629', // Darker shade of green
      background: '#ffffff',
      foreground: '#171717',
      'surface-header': '#FFFCEE',
    },
    dark: {
      primary: '#008236', // Base stays consistent
      secondary: '#00a64d', // Lighter shade for contrast
      accent: '#4caf50', // Softer green accent
      background: '#0a0a0a',
      foreground: '#ededed',
      'surface-header': '#FFFCEE',
    },
  },

  logo: `/lims/logo/land-logo-original-source-402x124.svg`,

  auth: {
    signin: {
      welcome: 'Welcome Back!',
      tagline:
        'Log In To Manage Land Records, Applications, Surveys, And Payments Easily.',
      heroImage: '/images/l_auth.png',
    },
  },

  favicon: `/lims/favicon/favicon.svg`,
  faviconSvg: `/lims/favicon/favicon.svg`,
  favicon64: `/lims/favicon/favicon-64x64.svg`,
  favicon128: `/lims/favicon/favicon-128x128.svg`,
  appleTouchIcon: `/lims/favicon/favicon-180x180.svg`,

  heroSection: {
    title: (
      <>
        <span className="text-white">Welcome to Nairobi </span>
        <span className="text-white">
          Land Information Management
        </span>
        <span className="text-white"> Portal</span>
      </>
    ),
    description: (
      <span className="text-white">
        Your gateway to efficient land records and management in Nairobi.
      </span>
    ),
    image: `/lims/images/lims-4k-cover.svg`,
  },

  servicesSection: {
    title: 'Services',
    description: 'Access County Land Services that align with your needs.',
    services: limsServices, // 👈 loaded from config/lims/services.ts
  },

  /** ===========================
   * Header Navigation (drives your current HTML/classes)
   * =========================== */
  header: {
    links: [
      {
        title: 'About',
        children: [
          {
            title: 'Land Information Management System',
            url: 'http://192.168.102.93:8080/share/page/site/nccg-edms/documentlibrary',
            external: true,
          },
          { title: 'Policy & Guidelines', url: '#' },
          { title: 'Projects & Initiatives', url: '#' },
        ],
      },
      {
        title: 'Services',
        kind: 'services', // special case to show all services in mega menu
        children: [
          {
            title: 'Survey',
            url: 'http://192.168.102.93:8080/share/page/site/nccg-edms/documentlibrary',
            external: true,
          },
          { title: 'Valuation & Rating', url: '#' },
          { title: 'Allocation & Leasing', url: '#' },
          { title: 'Section Plan Endorsement', url: '#' },
          { title: 'Ownership Verification', url: '#' },
          { title: 'Records Search', url: '#' },
          { title: 'Place Naming', url: '#' },
        ],
      },
      { title: 'City Map', url: '#' },
      {
        title: 'Publications',
        children: [
          {
            title: 'Fees, Guides & Forms',
            url: 'http://192.168.102.93:8080/share/page/site/nccg-edms/documentlibrary',
            external: true,
          },
          { title: 'Notices & Advertisements', url: '#' },
          { title: 'Maps & Plans', url: '#' },
          { title: 'Data Catalog', url: '#' },
        ],
      },
      { title: 'Report Land Issue', url: '/contact' },
    ] as HeaderLink[],
  },

  contact: {
    hq: {
      coords: [-1.2921, 36.8219], // Approx City Hall Nairobi
      label: 'Nairobi City County Headquarters – City Hall, Nairobi',
    },
    details: [
      {
        id: 'postal',
        label: 'Postal Address',
        value: (
          <>
            P.O. Box 30075-00100,
            <br />
            Nairobi, Kenya
          </>
        ),
      },
      {
        id: 'email',
        label: 'Email',
        value: <>info@nairobi.go.ke</>,
      },
      {
        id: 'tel',
        label: 'Telephone',
        value: <>020 222 2222</>,
      },
    ],
  },

  footer: {
    description:
      'The Nairobi Land Information Management Portal provides convenient access to a wide range of land services, from records and surveys to valuations and property management. Manage all your county-related land tasks securely in one place.',
    copyright: '© 2025 Nairobi City County Government. All rights reserved.',
    links: [
      { title: 'Land Rates', url: '#' },
      { title: 'Ground Rent', url: '#' },
      { title: 'Land Amendment', url: '#' },
      { title: 'Land Survey', url: '#' },
    ],
  },

  getApiBaseUrl: () => {
    if (typeof window !== 'undefined') {
      return (window as any).__RUNTIME_CONFIG__?.NEXT_PUBLIC_BASE_API;
    }
    return process.env.NEXT_PUBLIC_BASE_API;
  },
};
